/** @format — Parse TOOL_CALL_RESULT JSON for payment + display copy */

function normalizePaymentEvent(value) {
  if (!value || typeof value !== "object") return null;
  if (value.type === "open_payment_modal") return value;
  if (value.payment_data || value.session_id || value.payment_session_id) {
    return { type: "open_payment_modal", ...value };
  }
  return null;
}

export function parseToolCallResultContent(content) {
  if (content == null) return null;

  let data = content;
  if (typeof content === "string") {
    try {
      data = JSON.parse(content);
    } catch {
      return null;
    }
  }

  if (!data || typeof data !== "object") return null;

  const paymentEvent = normalizePaymentEvent(data.payment_event);
  const requiresPayment = Boolean(data.requires_payment);

  // dockporter-ai#394: `displayMessage` replaces the assistant bubble and wins
  // over the model's own streamed text (runAguiStreamTurn -> paymentDisplayText).
  // That override exists for ONE case: the payment gate, whose `message` is the
  // copy shown beside the payment modal. Lifting `message` off every tool result
  // let internal tool payloads speak as the agent -- an already-authenticated
  // booking rendered the guard's "User is already logged in." and dropped the
  // real reply. Only payment payloads may override the bubble.
  const isPaymentDisplay = Boolean(paymentEvent) || requiresPayment;
  const rawMessage = typeof data.message === "string" ? data.message.trim() : "";
  const displayMessage = isPaymentDisplay && rawMessage ? rawMessage : null;

  return {
    paymentEvent,
    displayMessage,
    requiresPayment,
    actionRequired: data.action_required ?? null,
  };
}
